<div class="container">  
  @if(
    INFO_SCREEN.ACCOUNT_CREATED === type
    || INFO_SCREEN.SUCCESS === type
  ){
    <img src="imgs/green_check.png" class="image">
  }@else if (INFO_SCREEN.EMAIL_VERIFICATION_PENDING === type) {
    <img src="imgs/warn_check.png" class="image">
  }@else if (INFO_SCREEN.SUBSCRIPTION_DONE === type) {
    <img src="imgs/icon.png" class="image">
  }

  @if(highlight){
    <div class="highlight">{{highlight | translate}}</div>
  }
  @if(info){
    <div class="info">{{info | translate:{email: (params ? params['email'] : '') } }}</div>
  }
  @if(message){
    <div class="message">{{message | translate}}</div>
  }

  @if(
    INFO_SCREEN.ACCOUNT_CREATED === type 
    || INFO_SCREEN.EMAIL_VERIFICATION_PENDING === type)
  {
    <mat-progress-bar mode="determinate" [value]="countdownProgress()"></mat-progress-bar>
  }
  <app-button
    [buttonLabel]="buttonLabel | translate"
    [buttonType]="BUTTON_TYPES.REGULAR"
    [buttonDisabled]="disabled()" 
    (click)="continue()">
  </app-button>

</div>